import { SelectField } from "$components/inputs";
import useCurrencyFormatter from "$routes/patient/[:patientId]/_lib/invoices/hooks/useCurrencyFormatter";
import { MenuItem, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import type { Payers } from "../types";

const useStyles = makeStyles({
  selectField: {
    margin: 0,
    paddingTop: 0,
  },
  tariffName: {
    fontSize: "12px",
    margin: 0,
  },
  listItem: {
    display: "block",
  },
});

export const TariffSelectInput = ({
  name,
  selectedTariff,
  payers,
  disabled,
}: {
  name: string;
  selectedTariff: string;
  payers: Payers[];
  disabled?: boolean;
}) => {
  const classes = useStyles();
  const { currencyFormatter } = useCurrencyFormatter();

  const { setValue } = useFormContext();

  useEffect(() => {
    setValue(name, selectedTariff);
  }, [name, selectedTariff, setValue]);

  return (
    <SelectField
      name={name}
      fullWidth
      hideHelper
      disabled={disabled}
      selectProps={{
        value: selectedTariff,
        className: classes.selectField,
        onChange: (e: React.ChangeEvent<HTMLSelectElement>) => {
          setValue(name, e.target.value, { shouldDirty: true });
        },
      }}
    >
      {payers?.map((payer) => (
        <MenuItem
          key={payer.tariffId}
          value={payer.tariffId}
          className={classes.listItem}
        >
          {currencyFormatter(payer.amountInPence)}
          <p className={classes.tariffName}>{payer.name}</p>
        </MenuItem>
      ))}
    </SelectField>
  );
};
